import {
  Client,
  ShopCart,
  User,
  OrderProduct,
  OrderBenefit,
  OrderSubscription,
  Order,
} from '../models';

export function mergeItemsAndUsersByClient(
  shopCart: ShopCart | Order,
  users: User[]
) {
  const clients: Client[] = setUsersInClients(users);

  const shopCartProducts = setClientsInShopCartItems(
    shopCart?.products,
    clients
  );
  const shopCartBenefits = setClientsInShopCartItems(
    shopCart?.benefits,
    clients
  );
  const shopCartSubscriptions = setClientsInShopCartItems(
    shopCart?.subscriptions,
    clients
  );

  return {
    ...shopCart,
    products: shopCartProducts,
    benefits: shopCartBenefits,
    subscriptions: shopCartSubscriptions,
  };
}

function setUsersInClients(users: User[]) {
  const filtered = users?.filter((user) => user?.client);

  return filtered?.map((user) => ({
    ...user?.client,
    user,
  }));
}

function setClientsInShopCartItems(
  items: OrderProduct[] | OrderBenefit[] | OrderSubscription[],
  clients: Client[]
) {
  return items?.map((item) => {
    const client = clients?.find((c) => c?._id === item?.client);
    return { ...item, client };
  });
}
